import { NgModule } from '@angular/core';
import { ResponsiveTableModule } from '@fantaz/shared/directives/responsive-table';
import { SharedUiTableComponentModule } from '@fantaz/shared/ui/table-component';
import { CashCardDetails } from './cash-card-details/cash-card-details';
import { TableViewComponent } from './table-view.component';

@NgModule({
  imports: [
    ResponsiveTableModule,
    SharedUiTableComponentModule,
    CashCardDetails,
  ],
  declarations: [TableViewComponent],
  exports: [TableViewComponent],
})
export class TournamentsUiRoomsTableViewModule {}
